<template lang="pug">
.campaign__detail-contents-body(v-html="detailContentsHtml")
</template>

<script>
import axios from 'axios'
import marked from'marked'
import {isEmpty} from 'lodash/lodash.min'

export default {

  computed: {
    detailContentsHtml: function() {
      if (isEmpty(this.detailContents)) {
        return ''
      }
      return marked(this.detailContents.content, {
        sanitize: true,
        breaks: true
      })
    }
  },

  created() {
    this.load()
  },

  data() {
    return {
      detailContents: '',
      jsonPath: (()=> {
        return location.pathname.replace(/\/$/, '') + '.json'
      })()
    }
  },

  methods: {
    load() {
      const csrf = document.querySelector('meta[name=csrf-token]')
      if (!_.isNull(csrf)) {
        axios.defaults.headers['X-CSRF-TOKEN'] = csrf.getAttribute('content')
      }
      axios.get(this.jsonPath)
        .then((response) => {
          this.detailContents = response.data.result.campaign.detail_contents
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }

}
</script>

<style lang="sass">
</style>
